export const MoreText = 'More';
